import { render, staticRenderFns } from "./FullName.vue?vue&type=template&id=23f5c806"
import script from "./FullName.vue?vue&type=script&lang=js"
export * from "./FullName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports